import { useI18n } from 'next-localization';
import PerformanceTableBase from 'components/Pages/FundsCenter/FundDetails/SecondLevelTabs/PerformanceTabs/Tables/PerformanceTableBase';
import { endpoints } from 'components/Pages/FundsCenter/FundDetails/SecondLevelTabs/PerformanceTabs/performanceEndpoints';

type Props = {
  classname?: string;
};

const CumulativeDailyTable = ({ className }: Props) => {
  const { t } = useI18n();
  return (
    <PerformanceTableBase
      title={t('fundDetailsCumulativeDailyPerformanceTitle')}
      footnoteText={t('fundDetailsPerformanceCumulativeFootnote')}
      wrapperId="cumulativeDailyWrapper"
      tableId="cumulativeDailyTable"
      endpoint={endpoints.CUMULATIVE_DAILY}
      className={className}
    />
  );
};

export default CumulativeDailyTable;
